import { BiddingBlockedReason } from "mws-ts-v2-sdk";

const useBiddingBlockedInfo = (
  biddingBlockedReason: MaybeRefOrGetter<
    BiddingBlockedReason | null | undefined
  >,
) => {
  const { t } = useI18n();

  return computed(() => {
    if (
      toValue(biddingBlockedReason) === BiddingBlockedReason.NoShipmentToTurkey
    ) {
      return {
        title: t("product.biddingBlocked.turkey.title"),
        text: t("product.biddingBlocked.turkey.text"),
      };
    }

    return {
      title: t("product.biddingBlocked.default.title"),
      text: t("product.biddingBlocked.default.text"),
    };
  });
};

export default useBiddingBlockedInfo;
